'use strict';
import React from 'react';
import Portal from 'react-portal';
import flux from 'utils/flux';
import AltContainer from 'alt-container';
import LoginModal from 'components/modals/loginModal';
import RegisterModal from 'components/modals/registerModal';
import PasswordForgottenModal from 'components/modals/passwordForgottenModal';
import MediaModal from 'components/modals/mediaModal';
import SharedModal from 'components/modals/sharedModal';
import InstantDownloadModal from 'components/modals/instantDownloadModal';
import InstantDownloadAllModal from 'components/modals/instantDownloadAllModal';
import ShareModal from 'components/modals/shareModal';
import ConfirmModal from 'components/modals/confirmModal';
import WatermarkModal from 'components/modals/watermarkModal'
import ExcelSearchModal from 'components/modals/excelSearchModal'
import Modal from './modal';


var ModalContainer = React.createClass({
    displayName: 'ModalContainer',
    mixins: [],
    propTypes: {},
    render() {
        var openModal = this.props.modalStore.openModal;
        // This is weird (Portal Bug), we have to
        // pass in a listener for the modals store
        // @TODO fix it!
        return (
            <div>
                <Portal isOpened={openModal === 'Media'}>
                    <Modal className="modal__media" closeOnOutsideClick={true}>
                        <AltContainer
                            stores={{
                                modalStore: flux.getStore('modals'),
                                mediaStore: flux.getStore('media')
                            }}
                            transform={({ modalStore, mediaStore }) => {
                                const media = modalStore.data;
                                const mediaMeta = mediaStore.modalMeta;
                                const slotDefinitions = mediaStore.slotDefinitions;
                                const modalOrientation = mediaStore.modalOrientation;
                                const slotConfig = mediaStore.slotConfig;
                                return { media, mediaMeta, slotDefinitions, modalOrientation, slotConfig };
                            }}>
                            <MediaModal />
                        </AltContainer>
                    </Modal>
                </Portal>
                <Portal isOpened={openModal === 'InstantDownload'}>
                    <Modal className="modal__instantdownload" closeOnOutsideClick={true}>
                        <AltContainer
                            stores={{ modalStore: flux.getStore('modals'), mediaStore: flux.getStore('media') }}
                            transform={({ modalStore, mediaStore }) => {
                                const media = modalStore.data;
                                const { quotaExceeded } = mediaStore;
                                return { media, quotaExceeded };
                            }}>
                            <InstantDownloadModal />
                        </AltContainer>
                    </Modal>
                </Portal>

                <Portal isOpened={openModal === 'InstantDownloadAll'}>
                    <Modal className="modal__instantdownload" closeOnOutsideClick={true}>
                        <AltContainer
                            stores={{ modalStore: flux.getStore('modals'), mediaStore: flux.getStore('media') }}
                            transform={({ modalStore, mediaStore }) => {
                                const media = modalStore.data;
                                const { quotaExceeded } = mediaStore;
                                return { media, quotaExceeded };
                            }}>
                            <InstantDownloadAllModal />
                        </AltContainer>
                    </Modal>
                </Portal>

                <Portal isOpened={openModal === 'PasswordForgotten'}>
                    <Modal className="modal__password-forgotten" closeOnOutsideClick={true}>
                        <AltContainer
                            stores={{appStore: flux.getStore('app')}}
                            transform={({ appStore }) => {
                                var hasError = appStore.error;
                                return { hasError };
                            }}>
                            <PasswordForgottenModal />
                        </AltContainer>
                    </Modal>
                </Portal>
                <Portal isOpened={openModal === 'Login'}>
                    <Modal className="modal__login" closeOnOutsideClick={true}>
                        <AltContainer
                            stores={{appStore: flux.getStore('app')}}
                            transform={({ appStore }) => {
                                var hasError = appStore.error;
                                return { hasError };
                            }}>
                            <LoginModal />
                        </AltContainer>
                    </Modal>
                </Portal>
                <Portal isOpened={openModal === 'Register'}>
                    <Modal className="modal__register" closeOnOutsideClick={false}>
                        <AltContainer
                            stores={{appStore: flux.getStore('app')}}
                            transform={({ appStore }) => {
                                var hasError = appStore.error;
                                return { hasError };
                            }}>
                            <RegisterModal />
                        </AltContainer>
                    </Modal>
                </Portal>
                <Portal isOpened={openModal === 'Share'}>
                    <Modal className="modal__share" closeOnOutsideClick={false}>
                        <AltContainer
                            stores={{basketStore: flux.getStore('basket')}}
                            transform={({ basketStore }) => {
                                var shareUrl = basketStore.shareUrl;
                                return { shareUrl };
                            }}>
                            <ShareModal />
                        </AltContainer>
                    </Modal>
                </Portal>
                <Portal isOpened={openModal === 'Confirm'}>
                    <Modal className="modal__confirm" closeOnOutsideClick={false}>
                        <AltContainer
                            stores={{appStore: flux.getStore('app'), modalStore: flux.getStore('modals')}}
                            transform={({ modalStore }) => {
                                var data = modalStore.data;
                                return { data };
                            }}>
                            <ConfirmModal />
                        </AltContainer>
                    </Modal>
                </Portal>
                <Portal isOpened={openModal === 'Watermark'}>
                    <Modal className="modal__watermark" closeOnOutsideClick={true}>
                        <AltContainer
                            stores={{modalStore: flux.getStore('modals')}}
                            transform={({ modalStore }) => {
                                var media = modalStore.data;
                                return { media };
                            }}>
                            <WatermarkModal />
                        </AltContainer>
                    </Modal>
                </Portal>
                <Portal isOpened={openModal === 'ExcelSearch'}>
                    <Modal className="modal__excelsearch" closeOnOutsideClick={true}>
                        <AltContainer
                            stores={{basketStore: flux.getStore('basket')}}
                            transform={({  basketStore }) => {
                                const excelError = basketStore.excelError;
                                return { excelError };
                            }}>
                            <ExcelSearchModal />
                        </AltContainer>
                    </Modal>
                </Portal>
            </div>
        );
    }
});

module.exports = ModalContainer;


// WEBPACK FOOTER //
// ./app/components/modals/index.jsx